import { Tag } from 'antd';
import React from 'react';
import { formatDateRange } from 'shared/constants/date';
import { dayjs } from 'shared/utils/date';

const DateRangeTag = ({ dateRange, short, ...props }) => {
  if (!dateRange) return null;

  return (
    <Tag {...props}>
      {formatDateRange(dayjs, dateRange.period, dateRange.startDate, dateRange.endDate, { short, week: 'Week' })}
    </Tag>
  );
};

export default DateRangeTag;
